<template>
    <div>
        <el-table :data="devices" @selection-change="changeSelection" border>
            <el-table-column align="center" type="selection" width="48" />
            <el-table-column align="center" label="设备编号" prop="deviceNo" />
            <el-table-column align="center" label="设备型号" prop="deviceType" />
            <el-table-column align="center" label="注册时间" prop="createTime" />
            <el-table-column align="center" label="版本" prop="version" />
            <el-table-column align="center" label="容量/G" prop="capacity" />
            <el-table-column align="center" label="联通状态">
                <template slot-scope="scope">
                    {{
                    STATUS_MAP[scope.row.status]
                    }}
                </template>
            </el-table-column>
            <el-table-column align="center" width="150" label="授权通道/物理通道">
                <template slot-scope="scope">
                    {{ scope.row.channel || scope.row.noFusionChannel }}/{{
                    scope.row.maxChannel
                    }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="授权信息">
                <template slot-scope="scope">
                    <p :title="scope.row.comment">
                        {{ AUTH_MAP[scope.row.auth] }}{{ ' ' }}
                        {{
                        scope.row.comment.length > 15
                        ? scope.row.comment.substr(0, 15) + '...'
                        : scope.row.comment
                        }}
                    </p>
                    <p v-if="scope.row.auth == AUTH_PROBATION">{{ scope.row.endTime }}</p>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300">
                <template slot-scope="scope">
                    <el-button @click="clickEditAuth(scope.row)" size="mini">修改授权</el-button>
                    <el-button @click="clickDownloadAuth(scope.row)" size="mini">下载授权</el-button>
                </template>
            </el-table-column>
        </el-table>
        <DialogEditAuth
            :form="form"
            :maxChannel="maxChannel"
            :visible="visible"
            @on-close="changeVisible"
            @on-ok="handleSubmit"
        />
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { STATUS_MAP, AUTH_MAP, AUTH_PROBATION } from '../../../libs/enum.js';
import { api } from '../../../service';
import DialogEditAuth from '../../../components/edit-auth';

const { mapState, mapActions } = createNamespacedHelpers('installDevice');

export default {
    components: { DialogEditAuth },
    data() {
        return {
            STATUS_MAP,
            AUTH_MAP,
            AUTH_PROBATION,
            visible: false,
            form: {},
            maxChannel: 0,
        };
    },
    computed: {
        ...mapState({
            devices: state => state.devices,
        }),
        siteId() {
            return this.$route.query.siteId;
        },
    },
    methods: {
        ...mapActions(['changeSelection', 'getDevices']),
        clickEditAuth(data) {
            this.changeVisible(true);
            const { agentId, maxChannel, siteId } = data;
            const isAgent = agentId ? 1 : siteId ? 0 : 1;
            this.form = {
                ...data,
                isAgent,
                channel: data.channel || data.noFusionChannel,
                noFusionChannel: data.noFusionChannel === 0 ? 0 : 1,
            };
            this.maxChannel = maxChannel;
        },
        clickDownload({ deviceId }) {
            const token = localStorage.getItem('token');
            window.open(
                `${api.device.download}?token=${token}&deviceId=${deviceId}`
            );
        },
        changeVisible(visible) {
            this.visible = visible;
            !visible ? (this.form = {}) : void 0;
        },
        handleSubmit() {
            this.getDevices({ siteId: this.siteId });
        },
    },
};
</script>
